import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { SiteControllerSettingAirHostReservationSyncJob_SettingPage_Query } from "../../../query/schema";
import { SiteControllerSettingAirHostReservationSyncStart_SettingPage_Mutation } from "../../schema";

export const useAirHostReservationSyncStartMutation = () => {
	const { mutationFunc } = useCustomMutation(SiteControllerSettingAirHostReservationSyncStart_SettingPage_Mutation);

	const onStartReservationSync = useCallback(
		async ({ hotelID }: { hotelID: string }) => {
			return await mutationFunc({
				variables: {
					input: { hotelID },
				},
				refetchQueries: [
					{
						query: SiteControllerSettingAirHostReservationSyncJob_SettingPage_Query,
						variables: { hotelID },
					},
				],
			});
		},
		[mutationFunc],
	);

	return { onStartReservationSync };
};
